import {
  SUBJECTS_OPTIONS,
  LEVELS_OPTIONS,
  YEARS_OPTIONS,
  DAY_OF_WEEK_OPTIONS,
} from 'utils/helpers/helper.constant';
import { generateAudienceIncludes } from 'utils/helpers/helper.generateData';

const descriptionFields = [
  {
    label: 'Formule de politesse',
    name: 'description.greeting',
    required: true,
    value: '',
    type: 'select',
    selectContent: [
      {
        key: 'M.',
        label: 'M.',
        value: 'M.',
      },
      {
        key: 'Mme.',
        label: 'Mme.',
        value: 'Mme.',
      },
    ],
    col: 6,
  },
  {
    label: 'Nom',
    name: 'description.lastname',
    required: true,
    value: '',
    type: 'input',
    col: 9,
  },
  {
    label: 'Prénom',
    name: 'description.firstname',
    required: true,
    value: '',
    type: 'input',
    col: 9,
  },
];

const classSelect = {
  label: 'Classe',
  name: 'class_info._id',
  displayLabel: true,
  required: true,
  value: '',
  endponit: 'classes/list',
  type: 'axios-select',
  col: 24,
  itemCallback: item => ({
    key: item._id,
    label: item.title,
    value: item._id,
  }),
};

const teacherSelect = {
  label: 'Titulaire de classe',
  name: 'incumbent._id',
  displayLabel: true,
  required: false,
  endponit: 'users/role',
  endponitSend: {
    role: 'teacher',
  },
  type: 'axios-select',
  col: 24,
  itemCallback: item => {
    return {
      key: item._id,
      label: `${item?.description?.lastname} ${item?.description?.firstname}`,
      value: item._id,
      item: item,
    };
  },
};

const initForm = (key, fieldsArray) => {
  return [
    {
      key: key,
      parentName: 'Informations générales',
      parentLabel: 'Informations générales',
      children: [...fieldsArray],
    },
    {
      children: [
        {
          label: 'Sauvegarder',
          name: 'send',
          value: 'send',
          type: 'submit',
        },
      ],
    },
  ];
};

// Custom Form for Users
const initFormsByRole = role => {
  switch (role) {
    case 'teacher':
      const formTeacher = [
        ...descriptionFields,
        {
          label: 'Adresse e-mail',
          name: 'email',
          required: true,
          value: '',
          type: 'email-validate',
          col: 24,
        },
        {
          label: 'Mot de passe',
          name: 'password',
          required: true,
          value: '',
          type: 'password',
          col: 24,
        },
        {
          label: 'N° téléphone',
          name: 'address.telephone',
          required: true,
          value: '',
          type: 'phone',
          col: 24,
        },
      ];
      return initForm('general_form_teacher', formTeacher);
    case 'parent':
      const formParent = [
        ...descriptionFields,
        {
          label: 'Adresse e-mail',
          name: 'email',
          required: true,
          value: '',
          type: 'email-validate',
          col: 24,
        },
        {
          label: 'Mot de passe',
          name: 'password',
          required: true,
          value: '',
          type: 'password',
          col: 24,
        },
        {
          label: 'N° téléphone',
          required: true,
          name: 'address.telephone',
          value: '',
          type: 'phone',
          col: 24,
        },
        {
          label: 'Adresse / Rue',
          required: true,
          name: 'address.street',
          value: '',
          type: 'input',
          col: 24,
        },
        {
          label: 'Adresse / Ville',
          required: true,
          name: 'address.city',
          value: '',
          type: 'input',
          col: 24,
        },
      ];
      return initForm('general_form_parent', formParent);

    case 'admin':
      const formAdmin = [
        ...descriptionFields,
        {
          label: 'Adresse e-mail',
          name: 'email',
          required: true,
          value: '',
          type: 'email-validate',
          col: 24,
        },
        {
          label: 'Mot de passe',
          name: 'password',
          required: true,
          value: '',
          type: 'password',
          col: 24,
        },
        {
          label: 'N° téléphone',
          name: 'address.telephone',
          required: true,
          value: '',
          type: 'phone',
          col: 24,
        },
      ];
      return initForm('general_form_admin', formAdmin);
  }
};

// Students General form
const initFormsStudents = () => {
  const mainFieldsStudent = [
    ...descriptionFields,
    {
      label: 'Classe',
      name: 'class_info._id',
      displayLabel: true,
      required: true,
      value: '',
      endponit: 'classes/list',
      type: 'axios-select',
      col: 24,
      itemCallback: item => ({
        key: item._id,
        label: item.title,
        value: item._id,
      }),
    }
  ];
  return initForm('general_form_student', mainFieldsStudent);
};

// Courses General form
const initFormsCourses = () => {
  const mainFieldsCourse = [
    {
      label: 'Matière color',
      name: 'subject.color', // for select-chain select field
      required: false,
      value: '',
      type: 'hidden',
      col: 24,
    },
    {
      label: 'Matière',
      name: 'subject.name',
      required: true,
      chain: 'subject.color',
      type: 'select-chain',
      selectContent: SUBJECTS_OPTIONS,
      col: 16,
    },
    {
      label: 'Nom du Cours',
      name: 'course_code',
      value: '',
      type: 'input',
      col: 8,
    },
    {
      label: 'Année',
      name: 'year',
      required: true,
      value: '',
      type: 'select',
      selectContent: YEARS_OPTIONS,
      col: 24,
    },
    {
      label: 'Niveau',
      name: 'level',
      value: 0,
      type: 'select',
      selectContent: LEVELS_OPTIONS,
      col: 12,
    },
    {
      label: 'N° de salle principale',
      name: 'class_room',
      value: '',
      type: 'input',
      col: 12,
    },
    {
      label: 'Jour de la semaine',
      name: 'course_week',
      required: true,
      value: 'lundi',
      type: 'select',
      selectContent: DAY_OF_WEEK_OPTIONS,
      col: 8,
    },
    {
      label: 'Heure (Début)',
      name: 'course_time_start',
      required: true,
      value: '',
      type: 'time-range',
      col: 8,
    },
    {
      label: 'Heure (Fin)',
      name: 'course_time_end',
      required: true,
      value: '',
      type: 'time-range',
      col: 8,
    },
    classSelect,
  ];
  return initForm('general_form_course', mainFieldsCourse);
};

// Classes General form
const initFormsClasses = () => {
  const mainFieldsClass = [
    {
      label: 'Année',
      name: 'year',
      required: true,
      value: '',
      type: 'select',
      selectContent: YEARS_OPTIONS,
      col: 12,
    },
    {
      label: 'Classe',
      name: 'title',
      required: true,
      value: '',
      type: 'input',
      col: 12,
    },
    {
      label: 'Niveau',
      name: 'level',
      required: true,
      value: 0,
      type: 'select',
      selectContent: LEVELS_OPTIONS,
      col: 24,
    },
    {
      label: 'N° de salle principale',
      name: 'class_room',
      value: '',
      type: 'input',
      col: 24,
    },
    teacherSelect
  ];
  return initForm('general_form_class', mainFieldsClass);
};

const initFormsCommunication = (communicationDetail, includes = []) => {

  let audienceSelect = {
    label: 'Audience',
    name: 'audience-select',
    endponit: `communications/audience/by/schools,students,courses,classes,audiences,users`,
    endponitSend: {
      value: '',
      include: includes || [],
      firstLoad: true,
    },
    displayLabel: true,
    required: true,
    type: 'axios-select-multiple',
    hasModeView: true,
    hiddenChain: 'audience',
    col: 24,
    method: 'POST',
    groupped: true,
    optionLabelProp: 'title', // 'label
    value: [],
    className: 'axios-select',
    mode: 'multiple',
    isSearch: true,
    placeholder: 'Selectionner le(s) audience',
    showAsTag: true,
    /*  tagRender: (props) => {
      console.log({ props });
      return <span className="multiple-label-list">{props.label}</span>;
    }, */
    /*  getResponse: response => {
      //console.log({ response });
    }, */
    onSearch: input => {},
    /*   itemCallback: item => ({
      key: item?.key || item?._id,
      title: item?.title,
      label: item?.label,
      value: item?.value,
      item: item,
    }), */
  };
  return [
    {
      key: 'general_form_communication',
      parentName: '',
      parentLabel: '',
      children: [
        audienceSelect,
        {
          label: '',
          name: 'audience',
          required: true,
          value: communicationDetail?.audience || {},
          type: 'hidden',
          col: 24,
        },
        {
          label: 'Title',
          name: 'title',
          required: true,
          value: communicationDetail?.title || '',
          type: 'hidden',
          col: 24,
        },
        {
          label: '',
          name: 'sender',
          required: true,
          value: null,
          type: 'hidden',
          col: 24,
        },
        {
          label: '',
          name: 'status',
          required: true,
          value: 'draft',
          type: 'hidden',
          col: 24,
        },
        {
          label: '',
          name: 'thumbnail',
          required: false,
          value: '',
          type: 'hidden',
          col: 24,
        },
        {
          label: '',
          name: 'types',
          required: ['no-type'],
          value: null,
          type: 'hidden',
          col: 24,
        },
        {
          label: 'Date butoir de lecture ou réponse (optionel)',
          onlyReadLabel: 'Date butoir',
          name: 'deadlineDate',
          required: false,
          hasModeView: true,
          value: null,
          type: 'date',
          col: 24,
        },
        {
          label: '',
          name: 'description',
          required: true,
          value: '',
          type: 'hidden',
          col: 24,
          placeholder: 'Descriptif des communications',
        },
        {
          label: '',
          name: 'description-editor',
          hiddenChain: 'description',
          required: false,
          value: '',
          hasModeView: false,
          type: 'rich-editor',
          type_editor: 'simple',
          col: 24,
          placeholder: 'Descriptif des communications',
          onChange: text => {
            //console.log({ text, form });
          },
        },
      ],
    },
    {
      children: [
        {
          label: 'Sauvegarder',
          name: 'send',
          value: 'send',
          type: 'submit',
        },
      ],
    },
  ];
};

// forms
export {
  initFormsByRole,
  initFormsStudents,
  initFormsCourses,
  initFormsClasses,
  initFormsCommunication,
};
